import { defineComponent as _defineComponent } from 'vue'
import type { SnowplowContext } from '@/helpers/tracking/providers';
import type { TrendingSpotlightModuleFragment } from '@/features/onboarded-home/types';

import BasicTitleCardFullImage from '@/components/list/title-card/BasicTitleCardFullImage.vue';
import SpotlightCardCornerTag from '@/features/onboarded-home/components/modules/spotlights/SpotlightCardCornerTag.vue';
import WatchNowButtonNew from '@/components/buttons/WatchNowButtonNew.vue';

import { useI18n } from '@/helpers/composables/useI18n';
import { formatRuntime } from '@/helpers/title-helper';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TrendingSpotlightModuleCard',
  props: {
    title: null,
    tagText: null,
    additionalContexts: { default: () => [] }
  },
  emits: ["onPosterClick"],
  setup(__props: any) {

const props = __props as { title: TrendingSpotlightModuleFragment['titles'][number], tagText?: string, additionalContexts: SnowplowContext[] };





const { t } = useI18n();

const bgc =
	'linear-gradient(90deg, #10161D 0%, rgba(16, 22, 29, 0) 100%), linear-gradient(0deg, rgba(16, 22, 29, 0.48), rgba(16, 22, 29, 0.48))';

const titleName = computed(() =>
	props.title.__typename === 'Season' ? props.title.show.content.title : props.title.content.title
);

const stats = computed(() => {
	const stats = `${props.title.content.originalReleaseYear}`;

	if (props.title.content.runtime == null) return stats;

	const { translationKey, hours, minutes } = formatRuntime(props.title.content.runtime);

	if (isNaN(hours)) return stats;

	return `${stats} &#183; ${t(translationKey, { hours, minutes })}`;
});

return { __sfc: true,props, t, bgc, titleName, stats, BasicTitleCardFullImage, SpotlightCardCornerTag, WatchNowButtonNew }
}

})